<template>
  <div class="fill-height">
    <v-layout wrap>
      <v-flex>
        <section>
          <v-snackbar
            v-model="dialog.snackbar"
            top
            right
            color="#B71C1C">
            <span class="body-1 font-weight-light white--text"
              v-html="message.success">
            </span>

            <template v-slot:action="{ attrs }">
              <v-btn
                class="body-1 font-weight-bold text-capitalize"
                color="white"
                icon
                v-bind="attrs"
                @click="dialog.snackbar = false">
                <v-icon>mdi-close-circle-outline</v-icon>
              </v-btn>
            </template>
          </v-snackbar>

          <v-row>
            <v-col 
              cols="12" 
              md="7">
              <v-card 
                flat
                outlined>
                <v-card-text>
                  <ValidationObserver ref="form">
                    <v-form class="text-left">
                      <div
                        class="mb-2"
                        style="font-size: 16px;">
                        Silahkan masukkan konten untuk halaman aplikasi Matur Dokter <b>Kontak Kami</b> dibawah ini:
                      </div>

                      <v-divider class="mb-6" style="border: 3px solid #eaeaea; border-radius: 50px;"/>

                      <div class="mb-6">
                        <div
                          class="mb-4">
                          <v-btn v-if="!add"
                            elevation="0"
                            style="background: #00acc133;"
                            class="body-2 text-capitalize font-weight-bold d-flex align-center cyan--text text-darken-1"
                            @click="add = true; reset();">
                            <v-icon size="18">mdi-plus-circle-outline</v-icon>

                            <span class="ml-1">
                              Tambah
                            </span>
                          </v-btn>

                          <v-btn v-else
                            elevation="0"
                            style="background: #B71C1C40;"
                            class="body-2 text-capitalize font-weight-bold d-flex align-center color-default"
                            @click="add = false; reset();">
                            <v-icon size="18">mdi-close-circle-outline</v-icon>

                            <span class="ml-1">
                              Tutup
                            </span>
                          </v-btn>
                        </div>

                        <div v-if="add"
                          style="min-height: 52.8vh;">
                          <v-row>
                            <v-col
                              cols="12"
                              md="2">
                              <uploadfolder v-model="upload.folder"
                                style="position: sticky; top: 0;">
                                <div slot="activator" class="cursor-pointer">
                                  <v-card 
                                    flat
                                    height="125"
                                    class="d-flex align-center justify-center"
                                    style="border-radius: 15px;
                                          border: 2px solid #eaeaea; 
                                          border-style: dashed;">
                                    <v-img v-if="!process.image && form_add.icon !== ''"
                                      alt="kominfo" 
                                      width="100%"
                                      height="120"
                                      gradient="to bottom, rgba(0, 0, 0, .1), rgba(0, 0, 0, .5)"
                                      :src="form_add.icon"
                                      class="ma-auto d-flex align-center text-center">
                                      <template v-slot:placeholder>
                                        <v-row
                                          class="fill-height"
                                          align="center"
                                          justify="center">
                                          <v-progress-circular 
                                            indeterminate 
                                            color="#B71C1C">
                                          </v-progress-circular>
                                        </v-row>
                                      </template>

                                      <v-icon 
                                        size="50" 
                                        color="white">
                                        mdi-cloud-upload-outline
                                      </v-icon>
                                    </v-img>

                                    <v-icon v-if="!process.image && form_add.icon === ''"
                                      size="50" 
                                      color="grey">
                                      mdi-cloud-upload-outline
                                    </v-icon>

                                    <v-progress-circular v-if="process.image"
                                      indeterminate
                                      color="#B71C1C">
                                    </v-progress-circular>
                                  </v-card>
                                </div>
                              </uploadfolder>
                            </v-col>

                            <v-col
                              cols="12"
                              md="9">
                              <div
                                class="mb-6">
                                <ValidationProvider 
                                  name="title" 
                                  rules="required" 
                                  v-slot="{ errors, valid }">
                                  <div class="body-2 mb-2">
                                    <span class="red--text">*</span>
                                    Judul
                                    <span class="error--text">
                                      (wajib diisi)
                                    </span>
                                  </div>
                                  
                                  <v-text-field
                                    v-on:keyup.enter="save"
                                    style="max-width: 50%;"
                                    dense
                                    outlined
                                    color="#B71C1C"
                                    hide-details
                                    placeholder="Contoh. Facebook"
                                    
                                    v-model="form_add.title"
                                    vvvv-uppercase
                                    :success="form_add.title !== '' && valid"
                                    :error-messages="errors"
                                    required>
                                    <template v-slot:append-outer>
                                      <div v-if="errors.length > 0">
                                        <v-tooltip top color="#ff5252">
                                          <template v-slot:activator="{ on }">
                                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                          </template>
                                          
                                          Judul {{ errors[0] }}
                                        </v-tooltip>
                                      </div>

                                      <div v-if="form_add.title !== '' && valid">
                                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                                      </div>
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </div>

                              <div
                                class="my-6">
                                <ValidationProvider 
                                  name="link" 
                                  rules="required" 
                                  v-slot="{ errors, valid }">
                                  <div class="body-2 mb-2">
                                    <span class="red--text">*</span>
                                    Link
                                    <span class="error--text">
                                      (wajib diisi)
                                    </span>
                                  </div>
                                  
                                  <v-text-field
                                    v-on:keyup.enter="save"
                                    style="max-width: 60%;"
                                    dense
                                    outlined
                                    color="#B71C1C"
                                    hide-details
                                    placeholder="Contoh. https://www.facebook.com/"
                                    
                                    v-model="form_add.link"
                                    vvvv-uppercase
                                    :success="form_add.link !== '' && valid"
                                    :error-messages="errors"
                                    required>
                                    <template v-slot:append-outer>
                                      <div v-if="errors.length > 0">
                                        <v-tooltip top color="#ff5252">
                                          <template v-slot:activator="{ on }">
                                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                          </template>
                                          
                                          Link {{ errors[0] }}
                                        </v-tooltip>
                                      </div>

                                      <div v-if="form_add.link !== '' && valid">
                                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                                      </div>
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </div>

                              <v-btn
                                @click="save_add"
                                elevation="0"
                                style="background: #00acc133;"
                                class="body-2 text-capitalize font-weight-bold d-flex align-center cyan--text text-darken-1">
                                <v-icon size="18">mdi-check-circle-outline</v-icon>

                                <span class="ml-1">
                                  Tambahkan
                                </span>
                              </v-btn>
                            </v-col>
                          </v-row>
                        </div>

                        <div v-else
                          style="min-height: 52.8vh;">
                          <v-list v-if="form.extra.sosmed.length > 0"
                            color="transparent"
                            class="my-1">
                            <v-list-item
                              v-for="(item, index) in form.extra.sosmed"
                              :key="index"
                              class="mb-4 py-1"
                              style="background: #eaeaea; border-radius: 5px;">
                              <v-list-item-avatar
                                size="45"
                                tile
                                style="border-radius: 5px;">
                                <v-img
                                  :src="item.icon"
                                  style="border-radius: 5px;">
                                  <template v-slot:placeholder>
                                    <v-row
                                      class="fill-height"
                                      align="center"
                                      justify="center">
                                      <v-progress-circular 
                                        indeterminate 
                                        color="#B71C1C">
                                      </v-progress-circular>
                                    </v-row>
                                  </template>
                                </v-img>
                              </v-list-item-avatar>

                              <v-list-item-content>
                                <v-list-item-title
                                  class="body-1 font-weight-bold mb-1">
                                  {{ item.title }}
                                </v-list-item-title>

                                <v-list-item-subtitle
                                  class="caption font-weight-light">
                                  {{ item.link }}
                                </v-list-item-subtitle>
                              </v-list-item-content>

                              <v-list-item-action-text
                                class="cursor-pointer">
                                <div @click="delete_add(index)"
                                  class="d-flex align-center color-default">
                                  <v-icon size="18" color="#B71C1C">mdi-delete-empty</v-icon>

                                  <span class="font-weight-bold ml-1">
                                    Hapus
                                  </span>
                                </div>
                              </v-list-item-action-text>
                            </v-list-item>
                          </v-list>

                          <Empty v-if="form.extra.sosmed.length < 1"
                            margin="my-16"
                            padding="pa-8"
                            font="body-2"
                            :size="100"
                            message="Kontak" />
                        </div>
                      </div>
                    </v-form>
                  </ValidationObserver>
                  
                  <v-alert 
                    type="error" 
                    text dense prominent 
                    class="mt-6"
                    v-show="message.error.length > 0"
                    v-html="message.error">
                  </v-alert>
                </v-card-text>

                <v-card-text
                  class="pt-0">
                  <v-divider class="mb-4" style="border: 3px solid #eaeaea; border-radius: 50px;"/>

                  <v-card-actions>
                    <v-spacer/>

                    <v-btn
                      color="#B71C1C"
                      elevation="0"
                      class="body-2 font-weight-bold text-capitalize white--text"
                      :disabled="process.form"
                      :loading="process.form"
                      v-on:keyup.enter="save()"
                      @click="save()">
                      <v-icon small class="mr-1">mdi-check-bold</v-icon>
                      Simpan
                    </v-btn>
                  </v-card-actions>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col 
              cols="12" 
              md="5"
              class="d-flex justify-center">
              <v-card
                flat
                width="350"
                height="75vh"
                style="border: 5px solid #e0e0e0; border-radius: 30px;">
                <v-card-title 
                  class="cursor-pointer pa-4"
                  style="border-radius: 25px 25px 15px 15px;
                        position: absolute;
                        width: 100%;
                        z-index: 10;
                        background: #B71C1C;">
                  <v-icon 
                    color="white">
                    mdi-arrow-left-thick
                  </v-icon>

                  <span
                    class="body-1 font-weight-bold text-capitalize white--text ml-1">
                    Kebijakan Privasi
                  </span>
                </v-card-title>

                <v-card-text 
                  class="pa-0 pt-6">
                  <gmap-map
                    ref="gmap"
                    :center="center"
                    :zoom="17"
                    :scrollwheel="false"
                    style="width:100%; 
                          height: 350px;">
                    <gmap-marker
                      v-for="(item, index) in list"
                      :key="index"
                      :position="item.latlng"
                      :icon="item.icon">
                    </gmap-marker>
                  </gmap-map>
                </v-card-text>

                <v-card-text
                  style="border-radius: 15px 15px 25px 25px; 
                      position: relative; 
                      top: -80px;
                      background: #FFF;
                      height: 43.7vh;">
                  <div class="mb-3">
                    <div class="title black--text">
                      Kontak Kami
                    </div>

                    <div class="body-2 font-weight-light black--text" style="opacity: 60%;">
                      Hubungi Matur Dokter di bawah ini:
                    </div>
                  </div>

                  <div class="body-2 font-weight-light line-text-second black--text"
                    style="overflow-y: auto; 
                          height: calc((100vh - 530px) - 100px);">
                    <div 
                      class="paragraph mb-3"
                      style="text-indent: 25px; text-align: justify;">
                      <v-skeleton-loader
                        v-for="(item, index) in process.load ? 4 : 1"
                        :key="index"
                        class="ma-auto"
                        :loading="process.load"
                        type="list-item-three-line">
                        <div>
                          <v-list v-if="form.extra.sosmed.length > 0"
                            color="transparent"
                            class="my-1">
                            <v-list-item
                              v-for="(item, index) in form.extra.sosmed"
                              :key="index"
                              class="mb-4 px-2"
                              style="background: #eaeaea; border-radius: 5px;">
                              <v-list-item-avatar
                                size="40"
                                tile
                                class="mr-0"
                                style="border-radius: 5px;">
                                <v-img
                                  :src="item.icon"
                                  style="border-radius: 5px;">
                                  <template v-slot:placeholder>
                                    <v-row
                                      class="fill-height"
                                      align="center"
                                      justify="center">
                                      <v-progress-circular 
                                        indeterminate 
                                        color="#B71C1C">
                                      </v-progress-circular>
                                    </v-row>
                                  </template>
                                </v-img>
                              </v-list-item-avatar>

                              <v-list-item-content>
                                <v-list-item-title
                                  class="body-2 font-weight-bold mb-1">
                                  {{ item.title }}
                                </v-list-item-title>

                                <v-list-item-subtitle
                                  class="caption font-weight-light">
                                  {{ item.link }}
                                </v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>

                          <div v-if="form.extra.sosmed.length < 1"
                            class="text-center my-16">
                            <v-img 
                              class="mx-auto"
                              contain
                              alt="vuetify"
                              :width="100"
                              :height="100"
                              :src="require('@/assets/image/empty.png')">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    indeterminate 
                                    color="#B71C1C">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>

                            <div 
                              class="body-1font-weight-light text-second my-6">
                              Belum ada data <b>Kontak</b>!!!
                            </div>
                          </div>
                        </div>
                      </v-skeleton-loader>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        dialog: {
          snackbar: false
        },
        center: {
          // DINKES
          lat: -7.7139,
          lng: 110.5918
        },
        list: [
          {
            text: 'Dinas Kesehatan Klaten',
            latlng: {
              lat: -7.7139,
              lng: 110.5918
            },
            icon: {}
          }
        ],
        add: false,
        upload: {
          folder: null
        },
        form: {
          id: '',
          title: '',
          content: '',
          status: 'publish',
          type: 'contactus',
          extra: {
            sosmed: []
          }
        },
        form_add: {
          title: '',
          icon: '',
          link: ''
        },
        process: {
          load: false,
          form: false,
          image: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetch: true */ '@/components/upload/folder.vue'),
      Empty: () => import(/* webpackPrefetch: true */ '@/components/empty')
    },
    watch: {
      'upload.folder': {
        handler: function () {
          if (this.upload.folder) {
            this.process.image = this.upload.folder.process

            if (!this.process.image) {
              // CALLBACK FROM UPLOAD IMAGE
              this.form_add.icon = this.upload.folder.data.full.file_url
            }
          }
        },
        deep: true
      }
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      rps() {
        return this.$vuetify.breakpoint.name
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      fetch () {
        this.fetchMarker()
        this.fetchData()
      },
      async fetchMarker () {
        this.$gmapApiPromiseLazy().then(() => {
          for (let i in this.list) {
            this.list[i].icon = {
              url: require('@/assets/image/location_pin_3.png'),
              scaledSize: new google.maps.Size(50, 50),
              origin: new google.maps.Point(0, 0),
              anchor: new google.maps.Point(25, 50)
            }
          }
        })
      },
      async fetchData () {
        this.process.load = true

        let params = {
          type: 'contactus'
        }

        await get('site', { params })
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.code === 200) {
            this.form = res.data[0]
          }
        })
      },
      reset () {
        this.form_add = {
          title: '',
          icon: '',
          link: ''
        }
      },
      async save_add () {
        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.form.extra.sosmed.push(this.form_add)

          this.add = false
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },
      delete_add (index) {
        this.form.extra.sosmed.splice(index, 1)
      },
      async save() {
        this.message.error = ''

        this.process.form = true

        // SAVE TO REST API
        await post(`site/update`, {
          data: this.form
        })
        .then((response) => {
          let res = response.data

          this.process.form = false

          if (res.code === 200) {
            this.dialog.snackbar = true
            this.message.success = res.message

            this.fetchData()
          } else {
            this.message.error = res.message
          }
        })
      }
    }
  }
</script>

<style>
  .content_quil .ql-toolbar.ql-snow {
    border-radius: 4px 4px 0px 0px;
  }
  .content_quil .ql-container.ql-snow {
    border-radius: 0px 0px 4px 4px;
    height: 480px;
  }
  .content_quil .quill-editor .ql-editor {
    min-height: 480px;
  }
</style>